import styled from 'styled-components'

export const FieldsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  > div {
    flex: 1;
  }
`

export const SourceWrapper = styled.div`
  margin-top: 16px;
  margin-right: 14px;
  position: relative;
  padding-right: 4px;

  > svg {
    top: 26px !important;
    right: -20px !important;
  }
`
